import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import Logo from './logo.png'
import './checkout.css'

/*
 * The page Stripe returns to after a successful payment.
 *
 * It used to render an empty <div> while the account was being created, so the
 * customer stared at a blank white page immediately after paying, and an
 * alert('Error') was the only thing they got if it failed. It also assumed
 * sessionStorage still held the form — if the payment finished in another tab,
 * or the browser cleared it, JSON.parse(null) threw and nothing was created.
 *
 * The request and its payload are unchanged.
 */

export default function CheckoutSuccess() {
  const search = useLocation().search
  const navigate = useNavigate()

  // 'working' | 'done' | 'nodata' | 'failed'
  const [state, setState] = useState('working')

  useEffect(() => {
    let saved = null
    try {
      const raw = sessionStorage.getItem('record')
      if (raw) saved = JSON.parse(raw)
    } catch (err) {
      saved = null
    }

    if (!saved) {
      // The payment went through — this is only about creating the account.
      setState('nodata')
      return
    }

    const recObj = {
      ...saved,
      SessionID: new URLSearchParams(search).get('session_id')
    }

    axios.post(process.env.REACT_APP_API_SERVER + 'manager/eshopsuccess', recObj)
      .then(res => {
        if (res.data.err === 0) {
          sessionStorage.setItem('Email', recObj.Email)
          sessionStorage.setItem('Password', recObj.Password)
          setState('done')
          // Let them read the confirmation before the redirect takes over.
          setTimeout(() => navigate('/login'), 2200)
        } else {
          setState('failed')
        }
      })
      .catch(() => setState('failed'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const shell = (children) => (
    <div className="co-page">
      <header className="co-top">
        <div className="co-brand">
          <img src={Logo} alt="123High" />
          <span>
            <span className="co-brand-name">123High</span>
            <span className="co-brand-sub" style={{ display: 'block' }}>manager</span>
          </span>
        </div>
      </header>
      <div className="co-center">{children}</div>
    </div>
  )

  if (state === 'working') {
    return shell(
      <div className="co-card-msg">
        <div className="co-mark"><span className="co-spin" aria-hidden="true"></span></div>
        <h2>Setting up your account</h2>
        <p>Your payment went through. This takes a few seconds — please do not close this page.</p>
      </div>
    )
  }

  if (state === 'done') {
    return shell(
      <div className="co-card-msg">
        <div className="co-mark co-mark-good">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5l5 5L20 7" /></svg>
        </div>
        <h2>You are all set</h2>
        <p>Your account is ready. Taking you to the sign-in page…</p>
      </div>
    )
  }

  if (state === 'nodata') {
    return shell(
      <div className="co-card-msg">
        <div className="co-mark co-mark-good">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5l5 5L20 7" /></svg>
        </div>
        <h2>Payment received</h2>
        <p>
          We could not finish creating your account in this browser — the details from the
          form are no longer here, which happens if the payment completed in another tab
          or window.
        </p>
        <p>Your payment is safe. Contact us and we will activate your account right away.</p>
      </div>
    )
  }

  return shell(
    <div className="co-card-msg">
      <div className="co-mark">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 8v5M12 17h.01" /><circle cx="12" cy="12" r="9" /></svg>
      </div>
      <h2>Payment received</h2>
      <p>
        <b>You have been charged and your payment is safe</b>, but we could not finish
        creating your account automatically.
      </p>
      <p>Contact us with the email you used and we will activate it right away.</p>
    </div>
  )
}
